export const CURRENT_USER_ENDPOINT = '/auth/me';
export const LOGIN_ENDPOINT = '/auth/login';
export const RESET_PASSWORD = '/auth/resetpass';
export const RESET_CONFIRM_JWT= '/auth/addnewpass';
